export function convertObjectToBooleans(values, initalBooleanValue) {
    if (initalBooleanValue === void 0) { initalBooleanValue = false; }
    return Object.keys(values).reduce(function (updatedValues, key) {
        updatedValues[key] = initalBooleanValue;
        return updatedValues;
    }, {});
}
export function convertObjectToString(values, initialValue) {
    if (initialValue === void 0) { initialValue = ''; }
    return Object.keys(values).reduce(function (updatedValues, key) {
        updatedValues[key] = initialValue;
        return updatedValues;
    }, {});
}
// The order of this list matters! (Monday first)
export var daysOfAWeekList = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday'
];
/*
    Exclude<T, U> – Exclude from T those types that are assignable to U.
    Extract<T, U> – Extract from T those types that are assignable to U.
    NonNullable<T> – Exclude null and undefined from T.
    ReturnType<T> – Obtain the return type of a function type.
    InstanceType<T> – Obtain the instance type of a constructor function type.
 */
export var MedicationExpiryType;
(function (MedicationExpiryType) {
    MedicationExpiryType["Fixed"] = "fixed";
    MedicationExpiryType["Chart"] = "chart";
})(MedicationExpiryType || (MedicationExpiryType = {}));
